import { render } from "./Datepicker.vue?vue&type=template&id=2887d29d"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"

import "./Datepicker.vue?vue&type=style&index=0&id=2887d29d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__